import { AccessToken, OktaAuth } from '@okta/okta-auth-js';
import ThruCd from 'rcd-cpp-workspace/db/thruCd';
import { CookieManager, SessionDetails } from './cookieManager';

let refreshTokenTimeout: any;
const expireEarlySeconds = 30;

export class AuthClient {
  private static client: OktaAuth = null;
  static clear = () => {
    if (AuthClient.client && AuthClient.client.tokenManager)
      AuthClient.client.tokenManager.clear();
  };

  static get = () => {
    if (AuthClient.client == null) {
      AuthClient.client = new OktaAuth({
        issuer: process.env.REACT_APP_OKTA_ISSUER,
        clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
        redirectUri: window.location.origin + '/auth/callback',
        responseType: ['token', 'id_token'],
        scopes: ['openid', 'profile', 'offline_access'],
        tokenManager: {
          expireEarlySeconds,
          autoRemove: false,
          autoRenew: false
        }
      });
    }

    return AuthClient.client;
  };
  static getAccessToken = async () => {
    let token = await getAccessToken();
    let expiresInMS = getExpiresInMs(token?.expiresAt, 10);
    if (!token || expiresInMS < 0) {
      await AuthClient.client.tokenManager.renew('accessToken');
      token = await getAccessToken();
      expiresInMS = getExpiresInMs(token?.expiresAt, 10);
    }
    if (token) {
      const expiresInMS = getExpiresInMs(token.expiresAt, 10);
      if (refreshTokenTimeout != null) clearTimeout(refreshTokenTimeout);

      CookieManager.setSessionDetails<SessionDetails>({
        sessionExpiryCounter: 0
      });
      refreshTokenTimeout = setTimeout(async () => {
        const t = await getAccessToken();
        if (t && getExpiresInMs(t.expiresAt) < 3500000) {
          await AuthClient.client.tokenManager.renew('accessToken');
        }
      }, Math.min(60000, expiresInMS));
    } else {
      return {} as AccessToken;
    }

    return token;
  };

  static getTokenExpiryInMs = async () => {
    const t = await getAccessToken();
    if (!t) return null;
    return getExpiresInMs(t.expiresAt);
  };
}

const getAccessToken = (): Promise<AccessToken> =>
  AuthClient.get().tokenManager.get('accessToken') as Promise<AccessToken>;

const getExpiresInMs = (expiresAt: number, extraEarlySeconds: number = 0) =>
  (expiresAt - expireEarlySeconds - extraEarlySeconds) * 1000 -
  new Date().getTime();

export const getToken = async () => {
  let token = await AuthClient.getAccessToken();
  return {
    thruCd: 'CPPN',
    accessToken: token.accessToken
  };
};
